
/**
 * Date preset utilities for Meta API insights
 */
import { INSIGHTS_DATE_PRESETS } from './constants';
import { InsightsDatePreset } from './types';

/**
 * Get available date presets for insights
 */
export function getInsightsDatePresets(): InsightsDatePreset[] {
  return INSIGHTS_DATE_PRESETS;
}
